import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useShipmentContext } from '../../../../components/ShipmentProvider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Property from '@afosto/app-components-react/Property';
import getHandlingListStatusLabel from '../../../../utils/getHandlingListStatusLabel';
import { boolean as booleanFormatter } from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';

const ShipmentStatusSection = () => {
  const intl = useIntl();
  const { shipment, handlingList } = useShipmentContext();

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        {shipment && (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Property
                label={intl.formatMessage(translations.shipmentStatusSection.overview.isOutbound)}
                value={booleanFormatter(shipment?.is_outbound)}
              />
              <Property
                label={intl.formatMessage(
                  translations.shipmentStatusSection.overview.handlingListStatus,
                )}
                value={getHandlingListStatusLabel(handlingList ?? {}, intl)}
              />
              <Property
                label={intl.formatMessage(translations.shipmentStatusSection.overview.isLabeled)}
                value={booleanFormatter(shipment?.is_labeled)}
              />
              <Property
                label={intl.formatMessage(translations.shipmentStatusSection.overview.isComplete)}
                value={booleanFormatter(shipment?.is_complete)}
              />
              <Property
                label={intl.formatMessage(
                  translations.shipmentStatusSection.overview.isOvercomplete,
                )}
                value={booleanFormatter(shipment?.is_overcomplete)}
              />
            </Grid>
            <Grid item xs={6}>
              <Property
                label={intl.formatMessage(translations.shipmentStatusSection.overview.isFinished)}
                value={booleanFormatter(shipment?.is_finished)}
              />
              <Property
                label={intl.formatMessage(translations.shipmentStatusSection.overview.isCancelled)}
                value={booleanFormatter(shipment?.is_canceled)}
              />
              <Property
                label={intl.formatMessage(translations.shipmentStatusSection.overview.isInTransit)}
                value={booleanFormatter(shipment?.is_in_transit)}
              />
              <Property
                label={intl.formatMessage(translations.shipmentStatusSection.overview.isListed)}
                value={booleanFormatter(shipment?.is_listed)}
              />
              <Property
                label={intl.formatMessage(translations.shipmentStatusSection.overview.isBoxed)}
                value={booleanFormatter(shipment?.is_boxed)}
              />
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default ShipmentStatusSection;
